import { forwardSignUpDocument } from '../../../../services/sign-up/sendDocumentToBack';
import { useToastsHook, useTranslation } from '@bcba/react-hooks';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getUrlFileFromAwsBySignupRequestUuid } from '../../../../services/public/getUrlFileFromAwsBySignupRequestUuid';
import { useSignupFormContext } from '../../context/useSignUpContext';
import { useEffect } from 'react';

export const useSignupSummary = () => {
  const { showErrorToast, showSuccessToast } = useToastsHook();
  const { t } = useTranslation();

  const { signUpRequestUuid, setIsDirty } = useSignupFormContext();

  useEffect(() => {
    setIsDirty(false);
  }, []);

  const { data: url, isLoading: isLoadingUrl } = useQuery({
    queryKey: ['permission-document', signUpRequestUuid],
    queryFn: async () =>
      signUpRequestUuid &&
      (await getUrlFileFromAwsBySignupRequestUuid(signUpRequestUuid)),
  });

  const { mutate: forwardMutate, isPending } = useMutation({
    mutationFn: async (email: string) =>
      signUpRequestUuid &&
      (await forwardSignUpDocument({ uuid: signUpRequestUuid, email })),
    onSuccess: () =>
      showSuccessToast({
        title: t('businessSignup.summary.toast.title.success'),
      }),
    onError: () =>
      showErrorToast({
        title: t('businessSignup.summary.toast.title.error'),
      }),
  });

  const onSubmit = (data: { email: string }) => forwardMutate(data.email);

  return { onSubmit, isPending, url, isLoadingUrl };
};

export default useSignupSummary;
